import { Analytics } from '@garmin/support-analytics';

class PageTitle {
  static constructTitle([...content], sep = '|', sendPageviewFlag = true) {
    let formattedTitle = '';

    if (typeof content !== 'undefined'
        && content
        && content.length > 0) {
      content.forEach((stringContent, index) => {
        if (content.length === 1) {
          formattedTitle += `${stringContent}`;
        } else if (index !== content.length - 1) {
          formattedTitle += `${stringContent} ${sep} `;
        } else {
          formattedTitle += `${stringContent}`;
        }
      });
      this.updateTitle(formattedTitle, sendPageviewFlag);
    }
  }

  static updateTitle(title, sendPageviewFlag) {
    document.title = title;

    if (sendPageviewFlag) {
      Analytics.sendPageview(window.location.href, document.title);
    }
  }
}

export default PageTitle;
